export default __webpack_public_path__ + "static/icon-white-2110cbff4f8b47862d3d17aa9b1ffc97.png";